import { h } from 'preact'
import { useEffect } from 'preact/hooks'
import { tagParser, updateCSSVarScrollbarWidth, safeHtml } from '../../js/modules/utilities'
import { attributesAnalytics } from '../../js/modules/component'
import smallLogo from './small-logo-orange.svg'
import logo from './logo-orange.png'
import iconAccessibilityVision from './icon-accessibility-vision.svg'
import iconEcoMode from './icon-eco-mode.svg'
import iconHandShake from './icon-hand-shake.svg'
import iconMedal from './icon-medal.svg'

export const StratMarque = ({ title, items, analytics }) => {
   useEffect(() => {
      updateCSSVarScrollbarWidth()
   }, [])

   const getIconSrc = (iconName) => {
      const iconMap = {
         Medal: iconMedal,
         'Eco-mode': iconEcoMode,
         'hand-shake': iconHandShake,
         'accessibility-vision': iconAccessibilityVision,
      }
      return iconMap[iconName] || ''
   }

   return (
      <div class="strat-marque pt-2 bg-dark text-white mt-3 mt-lg-2 mt-xl-3" {...attributesAnalytics(analytics)}>
         <div class="container-fluid">
            <div class="d-flex justify-content-between">
               <h2 class="no-signature mr-2" dangerouslySetInnerHTML={{ __html: safeHtml(tagParser(title)) }}></h2>
               <picture>
                  <source srcset={smallLogo} media="(max-width: 479.98px)" />
                  <img class="logo" src={logo} alt="" loading="lazy" />
               </picture>
            </div>

            <div class="row">
               <div class="col-12 col-md-10">
                  <ul class="row list-unstyled">
                     {items.map(({ icon, label }, index) => (
                        <li class="col-12 col-md-6" key={index}>
                           <p class="label lead mb-1 mb-md-2">
                              <img src={getIconSrc(icon)} alt="" class={`icone-${icon} mr-2`} loading="lazy" />
                              <span>{label}</span>
                           </p>
                        </li>
                     ))}
                  </ul>
               </div>
            </div>
         </div>
      </div>
   )
}
